import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { IonContent, Platform } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { AffiliateTrackerCallbackParams } from 'src/app/interfaces/affliation-interface';
import { BalanceModel } from 'src/app/models/balance-model';
import { AccountBalanceService } from 'src/app/services/balance/account-balance.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { WithdrawalService } from 'src/app/services/cashier/withdrawal.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { WithdrawalBaseComponent } from '../cashier/withdraw/withdrawal-base/withdrawal-base.component';
import { LogoutService } from "src/app/services/logout/logout.service";
import { Subscription } from 'rxjs';
import { SiteContentInterface } from 'src/app/interfaces/sitecontent-interface';
import { SiteContentService } from 'src/app/services/sitecontent/sitecontent.service';
import { SiteContentModel } from 'src/app/models/sitecontent-model';

@Component({
    selector: 'app-cooling-off',
    templateUrl: './cooling-off.component.html',
    styleUrls: ['./cooling-off.component.scss'],
})
export class CoolingOffComponent extends WithdrawalBaseComponent implements OnInit {

    @ViewChild('Content', { read: IonContent }) content: IonContent;

    iUnderstandButtonDisabled: boolean = false;
    public error = null;

    public accountBalances: BalanceModel;

    public withdrawalAccounts: Array<any> = [];
    // public payoutMethods: Array<any> = [];
    public selectedAccount: any;

    public withdrawalForm: FormGroup;
    public accountList: AbstractControl;
    public amount: AbstractControl;
    public currency_code: AbstractControl;

    public name: string;
    public address1: string;
    public address2: string;
    public city: string;
    public province: string;
    public postalCode: string;
    public stateEnvironment: String;

    public echeckEnabled: boolean = true;
    public offerWithdrawalFlag: boolean;
    public environmentName: string;
    private backButtonSubscribtion: Subscription;
    public labels: SiteContentInterface;
    public selectedCountry;
    public currencyLabel = 'USD';
    public canWithdrawCoolOffMethodsArray: Array<any> = [];
    public withdrawalAccountsFinalList: Array<any> = [];

    public hasVenmoDeposit: boolean = false;

    constructor(
        private withdrawService: WithdrawalService,
        private cashierService: CashierService,
        private events: EventsService,
        private logoutService: LogoutService,
        private navigator: Navigator,
        private balanceProvider: AccountBalanceService,
        private successMessageService: SuccessMessageService,
        public platform: Platform,
        private config: ConfigService,
        private siteContentService: SiteContentService
    ) {
        super();

        this.labels = new SiteContentModel();
        this.events.publish("event:lobby:hide");
        this.successMessageService.clearMessage();
        this.error = null;

        let appConfigInfo = this.config.getConfig();
        this.offerWithdrawalFlag = appConfigInfo.coolingoff_withdrawal;
        this.stateEnvironment = appConfigInfo.env;
    }

    ngOnInit() {

        if (this.config.getConfig().ECHECKSELECT_ENABLED == '0') {
            this.echeckEnabled = false;
        }

        this.selectedCountry = this.config.getConfig().FEATURE_SITE_COUNTRY_REGION ? this.config.getConfig().FEATURE_SITE_COUNTRY_REGION : 'CANADA';
        if (this.selectedCountry === "CANADA") {
            this.currencyLabel = "CAD"
        }
        this.backButtonSubscribtion = this.platform.backButton.subscribeWithPriority(101, () => {
            if (this.navigator.getActivePage() == 'CoolingOffPage') {
                this.closeModal();
            } else {
                this.navigator.back();
            }
        });

        let canWithdrawCoolOffMethods = this.config.getConfig().FEATURE_COOLOFF_WITHDRAWAL_METHOD_LIST ?? "CAGE,VEN,GP,PPD,SL,MZACH,PWB,INSTA,IDS,GDIE,CH";
        this.canWithdrawCoolOffMethodsArray = canWithdrawCoolOffMethods.split(',');

        this.withdrawalForm = new FormGroup(
            {
                amount: new FormControl('', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
                currency_code: new FormControl(''),
                accountList: new FormControl('', [Validators.required]),
            }
        )

        this.accountList = this.withdrawalForm.get('accountList');
        this.amount = this.withdrawalForm.get('amount');
        // this.cashierProvider.getPayoutMethods().subscribe((res) => {
        //     this.payoutMethods = res;
        // });


        Promise.all(
            [this.getDepositAccounts()]).then(function (values) { }
            );
        this.environmentName = this.config.getConfig().env;
    }

    ngOnDestroy() {
        if (this.backButtonSubscribtion) {
            this.backButtonSubscribtion.unsubscribe();
        }
    }

    ionViewDidEnter() {
        this.successMessageService.clearMessage();

        this.onGetBalance();

        this.name = this.withdrawService.customer.firstName + " " + this.withdrawService.customer.lastName;
        this.address1 = this.withdrawService.customer.address.street;
        this.address2 = this.withdrawService.customer.address.street2;
        this.city = this.withdrawService.customer.address.city;
        this.province = this.withdrawService.customer.address.state;
        this.postalCode = this.withdrawService.customer.address.postalCode;
    }

    onGetBalance() {

        this.balanceProvider.getBalance().subscribe(
            (balance: BalanceModel) => {
                if (balance) {
                    this.accountBalances = balance;
                }
            }
        );
        this.error = null;
    }

    onWithdraw() {
        this.successMessageService.clearMessage();
        this.error = null;

        let data: any = {};
        data.currency_code = this.cashierService.customer.preferredCurrency.currencyCode;
        data.amount = this.withdrawalForm.value.amount;

        let formValues = this.withdrawalForm.value.accountList.split(',');
        data.payment_type_code = formValues[0];
        data.customerAccountID = formValues[1];

        if (data.payment_type_code == 'CAGE') {
            data.isCagePayout = true;
        }

        this.withdrawService.callWithdraw(data).subscribe(
            (response: any) => {
                // this.logger.log("callWithdraw response = ", response);
                if (response && !!response.result) {
                    this.content.scrollToTop();

                    // send the withdrawal event
                    const depositEventData: AffiliateTrackerCallbackParams = {
                        customer_id: this.withdrawService.customer.customerId,
                        amount: this.withdrawalForm.get('amount').value,
                        transaction_id: response.payload.payoutID
                    }
                    setTimeout(() => this.events.publish('event:withdraw', depositEventData), 2000);

                    this.amount.setValue('');
                    this.amount.markAsPristine();
                    this.successMessageService.setMessage('Your withdrawal request has been received.');
                    this.balanceProvider.updateBalance();
                }
            },
            (error) => {
                this.content.scrollToTop();
                // handle all deposit errors in base
                this.error = this.handleError(error);
                // this.logger.log("callWithdraw error = ", error);
            }
        )

        this.error = null;
    }

    getDepositAccounts() {
        return new Promise((resolve, reject) => {
            this.cashierService.callListAccounts().subscribe(
                (response: any) => {
                    if (response && !!response.result) {
                        // - We will not offer Check option here
                        if (this.isEnabled('CHECK_ENABLED')) {
                            this.withdrawalAccounts.push({'paymentTypeCode' : 'CH'}); 
                        }

                        if (this.isEnabled('CASINOCAGE_ENABLED')) {
                            this.withdrawalAccounts.push({ 'paymentTypeCode': 'CAGE' });
                        }

                        let achVIPAccounts = response.payload
                            .filter(account => account.paymentTypeCode === "GP")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (achVIPAccounts.length > 0) {
                            //this.withdrawalAccounts['GP'] = achVIPAccounts;
                            let newArr: any = { 'paymentTypeCode': 'GP' };
                            newArr.values = achVIPAccounts;
                            this.withdrawalAccounts.push(newArr);
                        }


                        let paypalAccounts = response.payload
                            .filter(account => account.paymentTypeCode === "PPD")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (paypalAccounts.length > 0) {
                            let newArr: any = { 'paymentTypeCode': 'PPD' };
                            newArr.values = paypalAccounts;
                            this.withdrawalAccounts.push(newArr);
                        }

                        let prepaidAccounts = response.payload
                            .filter(account => account.paymentTypeCode === "SL")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (prepaidAccounts.length > 0) {
                            let newArr: any = { 'paymentTypeCode': 'SL' };
                            newArr.values = prepaidAccounts;
                            this.withdrawalAccounts.push(newArr);
                        }

                        let eSelectAccounts = response.payload
                            .filter(account => account.paymentTypeCode === "MZACH")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (eSelectAccounts.length > 0) {
                            let newArr: any = { 'paymentTypeCode': 'MZACH' };
                            newArr.values = eSelectAccounts;
                            this.withdrawalAccounts.push(newArr);
                        }

                        // PayWithMyBank (Online Banking by Trustly)
                        let pwmbAccounts = response.payload
                            .filter(account => account.paymentTypeCode === "PWB")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (pwmbAccounts.length > 0) {
                            let newArr: any = { 'paymentTypeCode': 'PWB' };
                            newArr.values = pwmbAccounts;
                            this.withdrawalAccounts.push(newArr);
                        }

                        //InstaDebit 
                        let instaDebitAccount = response.payload
                            .filter(account => account.paymentTypeCode === "INSTA")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (instaDebitAccount.length > 0) {
                            let newArr: any = { 'paymentTypeCode': 'INSTA' };
                            newArr.values = instaDebitAccount;
                            this.withdrawalAccounts.push(newArr);
                        }

                        //iDebit 
                        let iDebitAccount = response.payload
                            .filter(account => account.paymentTypeCode === "IDS")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (iDebitAccount.length > 0) {
                            let newArr: any = { 'paymentTypeCode': 'IDS' };
                            newArr.values = iDebitAccount;
                            this.withdrawalAccounts.push(newArr);
                        }

                        //Interac 
                        let interacAccount = response.payload
                            .filter(account => account.paymentTypeCode === "GDIE")
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (interacAccount.length > 0) {
                            let newArr: any = { 'paymentTypeCode': 'GDIE' };
                            newArr.values = interacAccount;
                            this.withdrawalAccounts.push(newArr);
                        }

                        //Venmo
                        this.hasVenmoDeposit = false;
                        const venmoAccount = response.payload
                            .filter(account => account.paymentTypeCode === "VEN" && account.dpstCnt > 0)
                            .map((account, key) => {
                                account.id = key;
                                return account;
                            });

                        if (venmoAccount.length > 0) {
                            const newArr: any = { 'paymentTypeCode': 'VEN' };
                            newArr.values = venmoAccount;
                            this.hasVenmoDeposit = true;
                            this.withdrawalAccounts.push(newArr);
                        }

                        console.log(this.canWithdrawCoolOffMethodsArray)
                        console.log(this.withdrawalAccounts)
                        //Check if config FEATURE_COOLOFF_WITHDRAWAL_METHOD_LIST has paymentTypeCode which we can show for CoolOff
                        var tempholdWithdrawalAccounts: any = this.withdrawalAccounts;
                        let i = 0;
                        for (let index in tempholdWithdrawalAccounts) {
                            for (let i = 0; i < this.canWithdrawCoolOffMethodsArray.length; i++) {
                                if (tempholdWithdrawalAccounts[index].paymentTypeCode == this.canWithdrawCoolOffMethodsArray[i]) {
                                    i++;
                                    this.withdrawalAccountsFinalList.push(tempholdWithdrawalAccounts[index]);
                                }
                            }

                        }
                        console.log('---Final Withdrawal List for User---', this.withdrawalAccountsFinalList)
                    }
                    resolve(true);
                },
                error => {
                    reject(); throw new Error("Calling list-accounts webservice returns error: " + error);
                }
            );
        });
    }
    private isEnabled(vendorEnabled) {
        return this.config.getConfig()[vendorEnabled] == '1';
    }

    closeModal = () => {
        this.logoutService.onLogout({ reason: 'COOLOFF_EXIT' });
    }
}
